define([
	"dojo/_base/declare",
	"Apparel/StructureItemSwitchboard",
	"Apparel/StructureItemThemeMixin"
], function(declare,StructureItemSwitchboard,StructureItemThemeMixin) {

    return declare([StructureItemSwitchboard,StructureItemThemeMixin],{

	});

});